'use client'

import { useTranslations } from 'next-intl'
import { Button } from '@/components/ui/button'
import { Link } from '@/i18n/routing'
import { IconArrowLeft } from '@tabler/icons-react'

interface BlogPostNavigationProps {
  previousPost: { slug: string; title: string } | null
  nextPost: { slug: string; title: string } | null
}

export function BlogPostNavigation({
  previousPost,
  nextPost
}: BlogPostNavigationProps) {
  const t = useTranslations('blog')

  if (!previousPost && !nextPost) {
    return null
  }

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:justify-between">
      {previousPost && (
        <Button asChild variant="outline" className="w-full sm:w-auto">
          <Link href={`/blog/${previousPost.slug}`}>
            <IconArrowLeft className="mr-2 h-4 w-4" />
            {t('previous')}: {previousPost.title}
          </Link>
        </Button>
      )}
      {nextPost && (
        <Button
          asChild
          variant="outline"
          className="w-full sm:ml-auto sm:w-auto"
        >
          <Link href={`/blog/${nextPost.slug}`}>
            {t('next')}: {nextPost.title}
            <IconArrowLeft className="ml-2 h-4 w-4 rotate-180" />
          </Link>
        </Button>
      )}
    </div>
  )
}
